<template>
  <div class="info" v-if="Object.keys(accountInfo).length > 0">
    <Row>
      <Col span="24"><h3>个人信息</h3></Col>
      <Col span="12">邮箱：{{accountInfo.email ? accountInfo.email : "暂无"}}</Col>
      <Col span="12">QQ：{{accountInfo.unionQQ ? accountInfo.unionQQ : "暂无"}}</Col>
      <Col span="12">联系地址：{{accountInfo.address ? accountInfo.address : "暂无"}}</Col>
      <Col span="24"><Button type="primary" @click="editShow">编辑资料</Button></Col>
    </Row>
    <edit ref="edit" :info="accountInfo" />
  </div>
</template>

<script>
import edit from "./cell/edit"
export default {
  name: "Info",
  components: {
    edit
  },
  computed: {
    accountInfo() {
      return this.$store.getters["account/accountInfo"]
    }
  },
  methods: {
    editShow() {
      this.$refs["edit"].modal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.info{
  .ivu-row{
    .ivu-col{
      margin-bottom: 20px;
    }
  }
}
</style>